// @flow
/** @jsx jsx */

import { Colors } from '@zapier/theme';
import { jsx } from '@emotion/core';
import { toRoleOption } from '@zapier/team/src/utils';
import {
  SelectField,
  type TextInputProps,
  TextInputWithComponent,
} from '@zapier/common-components';

type Props = {
  ...$Exact<TextInputProps>,
  onRoleChanged: string => void,
  roles: Array<string>,
  selectedRole?: string,
};

const roleCss = {
  background: Colors.storm,
  borderBottomRightRadius: 3,
  borderTopRightRadius: 3,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'center',
  minWidth: 120,
};

const EmailInviterInput = ({
  onRoleChanged,
  roles,
  selectedRole,
  ...props
}: Props) => {
  return (
    <TextInputWithComponent {...props}>
      {roles.length > 1 && (
        <div css={roleCss}>
          <SelectField
            isBorderHidden={true}
            isDark={true}
            isDisabled={props.isDisabled}
            items={roles}
            menuAriaLabel="List of available roles"
            onChange={option => {
              if (option) {
                onRoleChanged(option.value);
              }
            }}
            placeholder="Select Role"
            selectedItem={toRoleOption(selectedRole)}
          />
        </div>
      )}
    </TextInputWithComponent>
  );
};

export default EmailInviterInput;
